export default __webpack_public_path__ + "30c987e5bd3ad9c66fc54178bad61dc5.svg";